export const FREE_TX_COVERED_TEST_ID = 'free-tx-label'
